import keyBy from 'lodash/keyBy';

import SITE_STATUSES from './site_status_defs.json';

const SITE_STATUS_BY_NAME = keyBy(SITE_STATUSES, 'name');

const getDisplayNameOrThrowError = (name)=> {
  const status = SITE_STATUS_BY_NAME[name];

  if (!status || !status.name || !status.displayName) {
    throw new Error(`Programmer Error: name ${name} not correctly specified`);
  }

  return status.displayName;
};

export { SITE_STATUSES };

export const STATUS_ARCHIVED = getDisplayNameOrThrowError('STATUS_ARCHIVED');
export const STATUS_DEACTIVATED = getDisplayNameOrThrowError('STATUS_DEACTIVATED');
export const STATUS_REDIRECTED = getDisplayNameOrThrowError('STATUS_REDIRECTED');
export const STATUS_NEVER_PUBLISHED = getDisplayNameOrThrowError('STATUS_NEVER_PUBLISHED');
export const STATUS_NO_LINKS = getDisplayNameOrThrowError('STATUS_NO_LINKS');
export const STATUS_ACTIVE = getDisplayNameOrThrowError('STATUS_ACTIVE');
export const STATUS_NO_CLONEABLE_VERSION = getDisplayNameOrThrowError('STATUS_NO_CLONEABLE_VERSION');
export const STATUS_UP_TO_DATE = getDisplayNameOrThrowError('STATUS_UP_TO_DATE');
